export const creditMemoSampleData = {
  list: [
    {
      id: 1,
      note: 'Test Credit Memo',
      currency: 'USD',
      amount: 100.0,
      amountCustomerCurrency: 100.0,
      invoices: [
        {
          id: 1,
          currency: 'USD',
          status: 'DISPUTE',
          deleted: false,
          invoice_no: 'I0001',
          invoice_title: 'I0001',
          balance_due_amount: 100.0,
          balance_due_amount_base_currency: 100.0,
          amount: 33349.41,
          amount_base_currency: 33349.41,
          due_date: '2024-05-11 00:00:00',
          status_updated_date: '2024-06-11T14:52:38+0000',
          payment_status: 'PENDING',
          followup_status: 'DISPUTE_OPEN',
          invoice_date: '2024-03-27 00:00:00',
          created_by: {
            id: 1,
            hash: 'W3lhn4FkF45Kxo',
            email: 'vignesh.iyappan@growfin.ai',
            first_name: 'vignesh.iyappan',
            last_name: 'Iyappan',
          },
          created_date: '2024-05-16T05:47:21+0000',
          closed_date: '2024-03-27 00:00:00',
          last_activity_type: 'DISPUTE_OPEN',
          last_activity_date: '2024-06-11T14:52:38+0000',
          predicted_pay_date: '2022-04-05 12:48:36',
          draft_invoice: false,
        },
      ],
      reference: 'TEST',
      comments: null,
      status: 'APPLIED',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-07-01T00:00:00+0000',
      amount_base_currency: 100.0,
      amount_customer_currency_data: {
        value: 100.0,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 100.0,
            currency: 'USD',
            value_in_transformed_currency: 100.0,
            transformed_currency: 'USD',
          },
        ],
      },
      amount_data: {
        value: 100.0,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 100.0,
            currency: 'USD',
            value_in_transformed_currency: 100.0,
            transformed_currency: 'USD',
          },
        ],
      },
      applied_amount_data: {
        value: 100.0,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 100.0,
            currency: 'USD',
            value_in_transformed_currency: 100.0,
            transformed_currency: 'USD',
          },
        ],
      },
      unapplied_amount_data: {
        value: 100.0,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 100.0,
            currency: 'USD',
            value_in_transformed_currency: 100.0,
            transformed_currency: 'USD',
          },
        ],
      },
      memo_created_by: {
        id: 1,
        email: 'joette.korus@peace.com',
        type: 'PRIMARY_CONTACT',
        designation: null,
        first_name: 'Joette',
        last_name: 'Korus',
        phone_number: null,
        mobile_number: null,
        contact_type: {
          id: 1,
          display_text: 'Primary',
          default: true,
        },
        source_channel: null,
        participant_relation: null,
        source_app: 'CRM',
      },
      credit_memo_date: '2024-08-01T00:00:00+0000',
      closed_by: null,
      closed_date: null,
      comment_count: null,
      subsidiary: {
        id: 1,
        name: 'Test-Subsidiary-1',
        currency: 'USD',
        display_name: 'Test',
        logo_url: null,
      },
      applied_amount: 100.0,
      unapplied_amount: 100.0,
      applied_amount_base_currency: 100.0,
      unapplied_amount_base_currency: 100.0,
    },
  ],
  total_records: 1,
  current_page: 1,
  total_pages: 1,
};
